import { styled } from '@linaria/react';

import { fonts, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const SectionTitle = styled.h3`
  font-family: ${fonts.body};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const AcceptedCardsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${space['space-200']};
`;

export const FormError = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.danger};
`;
